import { SafeUrl } from '@angular/platform-browser';

export class OfflineProfilePicture {
  constructor(
    public name: string,
    public type: string,
    public size: number,
    public localFileUuid: string,
    public localSafeUrl: SafeUrl,
    public base64?: string
  ) {}
}
